<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">清风论坛></span>
        <span @click="GoreportEvaluation">警示教育></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>襄州区通报9起酒驾醉驾典型案例</h1>
        <h2>
          来源：新华社
          <span class="mg-16">|</span>
          发布时间：2020-03-30&nbsp;13:30
        </h2>
        <h3>
          <b>1.襄州区市场监督管理局石桥市场监督管理所原四级主任科员杨国徽醉酒驾驶问题。</b>
        </h3>
        <h3>2019年2月20日14时许，杨国徽驾驶小型轿车行驶至黄老线石桥镇十字街路口处，被公安交警查获。经检测，杨国徽血液中“酒精”成分含量为158.21mg/100ml，为醉酒后驾车。同年8月，杨国徽因犯危险驾驶罪，被判处拘役2个月、缓刑2个月。2019年12月，杨国徽受到开除公职处分。.76%，同比增长7.25%。主要原因是由于各地各单位受理信访举报的时间不同，信访人担心信访件未被受理或重视不够，在等待的过程中重复反映问题，导致重复访数量居高不下。2019年越级访15件次，同比下降57.14%。主要原因是枣阳市纪委监委领导班子认真执行定期下访接访制度，主要领导每周四固定接访，去年共接待群众面访36批次581人次，上访对象无一人越级访，有效缓解了全市大信访压力，越级访乱象得到了遏止；二是自办案件增加，上级转交件下降。2019年共受理信访举报995件，同比基本持平。其中本级自收573件，占57.59%，同比增长57.85%；上级转交办422件，占42.41%，同比下降33.02%。主要原因是随着全面从严治党不断向纵深推进，信访干部履职尽责意识不断增强，办信办访能力增强，加之信访渠道的通畅及日益拓宽，干部主动接访、带案下访、重点约访的机制发挥了积极作用，群众在本级信访诉求能够得到有效解决，越级向上反映问题大幅减少。三是信访反映村级干部增加，乡科级干部减少。2019年信访反映村（社区）人员419件，同比增长16.06%，反映乡科级干部198件，同比下降30.5%。从中不难看出在全面从严治党的高压态势下，不敢腐的震慑已经形成，不能腐的笼子正在扎牢，不想腐的自觉逐步增强，但从村干部信访举报持续增长的趋势显示，全面从严治党“最后一米”的问题还不够彻底，违反群众纪律和廉洁纪律类问题仍然居高不下，破坏了党群干群关系，蚕食了群众切身利益。 闵翼飞）</h3>
        <h3>
          <b>2.襄州区财政局非税收入征收管理局工作人员李关键醉酒驾驶问题。</b>
        </h3>
        <h3>2019年4月29日22时许，李关键驾驶小型普通客车行驶至樊城区清河路长征路小学门前路段处，被公安交警查获。经检测，李关键血液中“酒精”成分含量为194.26mg/100ml，为醉酒后驾车。同年8月，李关键因犯危险驾驶罪，被判处拘役2个月、罚金3000元。2019年10月，李关键受到开除党籍、降低岗位等级处分。</h3>
        <h3>
          <b>3.襄州区人民医院后管办工作人员胡建强醉酒驾驶问题。</b>
        </h3>
        <h3>2019年5月26日22时30分，胡建强驾驶小型客车行驶至樊城区清河路长征路小学门前路段处，被公安交警查获。经检测，胡建强血液中“酒精”成分含量为189.58mg/100ml，为醉酒后驾车。同年7月，胡建强因犯危险驾驶罪，被判处拘役2个月、缓刑3个月、罚金1万元。2019年9月，胡建强受到开除党籍处分。同年12月，胡建强受到降低岗位等级处分。</h3>
        <h3>
          <b>4.襄州区张家集镇杨庄小学梅铺教学点教师余国俭醉酒驾驶问题。</b>
        </h3>
        <h3>2019年4月13日23时47分，余国俭驾驶小型轿车行驶至樊城区长虹路沃尔玛超市门前路段处，被公安交警查获。经检测，余国俭血液中“酒精”成分含量为240.43mg/100ml，为醉酒后驾车。同年6月，余国俭因犯危险驾驶罪，被判处拘役2个月，缓刑3个月，并处罚金1万元。2019年8月，余国俭受到开除党籍处分。同年9月，余国俭受到降低岗位等级处分。</h3>
        <h3>
          <b>5.襄州区财政局行政事业收费票据管理中心科员陈革春饮酒驾驶问题。</b>
        </h3>
        <h3>2019年5月5日（工作日）14时许，陈革春驾驶小型轿车行驶至襄州区卧龙路与荣华路交叉路口处，与对向直行的三轮摩托车发生碰撞，致两人受伤，三轮车受损。经检测，陈革春血液中“酒精”成分含量为42.83mg/100ml，为饮酒后驾车。同年5月，襄州区公安局交警大队给予陈革春罚款2000元、暂扣机动车驾驶证6个月、扣12分的行政处罚。2019年12月，陈革春受到党内严重警告处分。.15万元，并将其中的5.7万元用于支付王台村在餐馆就餐及购买烟酒费用。2020年4月，朱学强、邹兆亮分别受到党内严重警告处分、党内警告处分。</h3>
        <h3>
          <b>6.襄州区招商服务中心办公室副主任齐庆峰饮酒驾驶问题。</b>
        </h3>
        <h3>2018年11月6日21时18分，齐庆峰驾驶小型轿车行驶至襄州区航空路与金富士路西侧处，与同向小型轿车发生碰撞，致两车受损，并驾车逃逸。经检测，齐庆峰血液中“酒精”成分含量为68.23mg/100ml，为饮酒后驾车。同年11月，襄州区公安局交警大队给予齐庆峰行政罚款4000元、暂扣机动车驾驶证6个月、扣24分的行政处罚。2020年5月，齐庆峰受到党内严重警告处分。.15万元，并将其中的5.7万元用于支付王台村在餐馆就餐及购买烟酒费用。2020年4月，朱学强、邹兆亮分别受到党内严重警告处分、党内警告处分。</h3>
        <h3>
          <b>7.襄州区供销社经济发展科科长吴兴功饮酒驾驶问题。</b>
        </h3>
        <h3>2019年6月29日16时55分，吴兴功驾驶小型轿车行驶至襄州区西湾路涵洞处，被公安交警查获。经检测，吴兴功血液中“酒精”成分含量为70mg/100ml，为饮酒后驾车。同年7月，襄州区公安局交警大队给予吴兴功罚款2000元、暂扣机动车驾驶证6个月、扣12分的行政处罚。2020年5月，吴兴功受到党内警告处分。.23mg/100ml，为饮酒后驾车。同年11月，襄州区公安局交警大队给予齐庆峰行政罚款4000元、暂扣机动车驾驶证6个月、扣24分的行政处罚。2020年5月，齐庆峰受到党内严重警告处分。.15万元，并将其中的5.7万元用于支付王台村在餐馆就餐及购买烟酒费用。2020年4月，朱学强、邹兆亮分别受到党内严重警告处分、党内警告处分。</h3>
        <h3>
          <b>8.襄州区龙王镇中心小学教师张爱武饮酒驾驶问题。</b>
        </h3>
        <h3>2019年3月6日14时54分，张爱武驾驶小型轿车行驶至龙王镇黑牛线28公里400米处，被公安交警查获。经检测，张爱武血液中“酒精”成分含量为23.8mg/100ml，为饮酒后驾车。同年3月，襄州区公安局交警大队给予张爱武罚款2000元、暂扣机动车驾驶证6个月、扣12分的行政处罚。2019年11月，张爱武受到党内警告处分。.23mg/100ml，为饮酒后驾车。同年11月，襄州区公安局交警大队给予齐庆峰行政罚款4000元、暂扣机动车驾驶证6个月、扣24分的行政处罚。2020年5月，齐庆峰受到党内严重警告处分。.15万元，并将其中的5.7万元用于支付王台村在餐馆就餐及购买烟酒费用。2020年4月，朱学强、邹兆亮分别受到党内严重警告处分、党内警告处分。</h3>
        <h3>
          <b>9.襄州区人民医院保卫科副主任齐清理饮酒驾驶问题。</b>
        </h3>
        <h3>2019年1月28日16时许，齐清理驾驶小型轿车行驶至襄州区航空路与金富士路口处，被公安交警查获。经检测，齐清理血液中“酒精”成分含量为68mg/100ml，为饮酒后驾车。同年1月，襄州区公安局交警大队给予齐清理罚款2000元、暂扣机动车驾驶证6个月、记12分的行政处罚。2019年12月，齐清理受到党内警告处分。（襄州区纪委监委）.23mg/100ml，为饮酒后驾车。同年11月，襄州区公安局交警大队给予齐庆峰行政罚款4000元、暂扣机动车驾驶证6个月、扣24分的行政处罚。2020年5月，齐庆峰受到党内严重警告处分。.15万元，并将其中的5.7万元用于支付王台村在餐馆就餐及购买烟酒费用。2020年4月，朱学强、邹兆亮分别受到党内严重警告处分、党内警告处分。</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PicBannertest1: require("../../../../assets/image/bannertest1.jpg"),
      PicBannertest2: require("../../../../assets/image/bannertest2.jpg")
    };
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      this.$router.push({ name: "forumWarning" });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
   text-align: center;
  display: flex;
  justify-content: center;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
  margin-bottom: 30px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
.text h3 b {
  display: block;
  margin-top: 20px;
}
img{
  margin: 20px 0px;
}
.mg-16{
  margin: 0px 16px;
}
</style>